import { http } from 'helpers/httpv2';

const URL_V2 = process.env.REACT_APP_API_V2;
const dashboard = 'okr/dashboard';
const teamDashboard = 'team/management/dashboard/progress';
const departmentDashboard = 'department/management/dashboard/progress';

export const apiOkrDashboard = async (val) => {
  const datas = await http.get(`${URL_V2 + dashboard}`);
  return datas.data.data;
};
export const apiTeamDashboard = async (val) => {
  const url = `${URL_V2 + teamDashboard}?page=1&page_size=100`;
  const datas = await http.get(`${url}`);
  return datas.data.data;
};
export const apiDepartmentDashboard = async (val) => {
  const url = `${URL_V2 + departmentDashboard}?page=1&page_size=100`;
  const datas = await http.get(`${url}`);
  return datas.data.data;
};
